<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Package Item</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Package Item</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Package Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click.native="doPkgSubItem">
            Package Sub-Item
            <v-icon right dark>mdi-view-list</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="mainForm.itemNo"
                  :label="labels.itemNo"
                  :error-messages="errors.collect('itemNo')"
                  data-vv-name="itemNo"
                  :data-vv-as="labels.itemNo"
                  v-validate="'required|numeric|mask_min_value:1|max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.itemNo }}</v-subheader>
                <div class="queryValue">{{ mainForm.itemNo }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defStdItemTxtRef"
                  v-model="mainForm.defStdItemTxtRef"
                  :label="labels.defStdItemTxtRef"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defStdItemTxtRef')"
                  data-vv-name="defStdItemTxtRef"
                  :data-vv-as="labels.defStdItemTxtRef"
                  v-validate="'entry'"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defUOM"
                  v-model="mainForm.defUOM"
                  :label="labels.defUOM"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defUOM')"
                  data-vv-name="defUOM"
                  :data-vv-as="labels.defUOM"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="uomUN"
                  v-model="mainForm.uomUN"
                  :label="labels.uomUN"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('uomUN')"
                  data-vv-name="uomUN"
                  :data-vv-as="labels.uomUN"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defBenefit"
                  v-model="mainForm.defBenefit"
                  :label="labels.defBenefit"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defBenefit')"
                  data-vv-name="defBenefit"
                  :data-vv-as="labels.defBenefit"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.uomAmt"
                  :label="labels.uomAmt"
                  :error-messages="errors.collect('uomAmt')"
                  data-vv-name="uomAmt"
                  :data-vv-as="labels.uomAmt"
                  v-validate="'numeric|max:18'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.minSI"
                  :label="labels.minSI"
                  :error-messages="errors.collect('minSI')"
                  data-vv-name="minSI"
                  :data-vv-as="labels.minSI"
                  v-validate="'numeric|max:18'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.maxSI"
                  :label="labels.maxSI"
                  :error-messages="errors.collect('maxSI')"
                  data-vv-name="maxSI"
                  :data-vv-as="labels.maxSI"
                  v-validate="'numeric|max:18'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.incSI"
                  :label="labels.incSI"
                  :error-messages="errors.collect('incSI')"
                  data-vv-name="incSI"
                  :data-vv-as="labels.incSI"
                  v-validate="'numeric|max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.mandOnPlan"
                  v-model="mainForm.mandOnPlan"
                  :error-messages="errors.collect('mandOnPlan')"
                  data-vv-name="mandOnPlan"
                  :data-vv-as="labels.mandOnPlan"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse1"
                  :label="labels.defClse1"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse1')"
                  data-vv-name="defClse1"
                  :data-vv-as="labels.defClse1"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.permitDel"
                  v-model="mainForm.permitDel"
                  :error-messages="errors.collect('permitDel')"
                  data-vv-name="permitDel"
                  :data-vv-as="labels.permitDel"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse2"
                  :label="labels.defClse2"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse2')"
                  data-vv-name="defClse2"
                  :data-vv-as="labels.defClse2"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.protSI"
                  v-model="mainForm.protSI"
                  :error-messages="errors.collect('protSI')"
                  data-vv-name="protSI"
                  :data-vv-as="labels.protSI"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse3"
                  :label="labels.defClse3"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse3')"
                  data-vv-name="defClse3"
                  :data-vv-as="labels.defClse3"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.protPrem"
                  v-model="mainForm.protPrem"
                  :error-messages="errors.collect('protPrem')"
                  data-vv-name="protPrem"
                  :data-vv-as="labels.protPrem"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.applyIndex"
                  v-model="mainForm.applyIndex"
                  :error-messages="errors.collect('applyIndex')"
                  data-vv-name="applyIndex"
                  :data-vv-as="labels.applyIndex"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.indexYr"
                  :label="labels.indexYr"
                  :error-messages="errors.collect('indexYr ')"
                  data-vv-name="indexYr "
                  :data-vv-as="labels.indexYr"
                  v-validate="'numeric|max:10'"
                  :disabled="doApplyIndex"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.indexPct"
                  :label="labels.indexPct"
                  :error-messages="errors.collect('indexPct')"
                  data-vv-name="indexPct"
                  :data-vv-as="labels.indexPct"
                  v-validate="'numeric|max:3'"
                  :disabled="doApplyIndex"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="indexOn"
                  v-model="mainForm.indexOn"
                  :label="labels.indexOn"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('indexOn')"
                  data-vv-name="indexOn"
                  :data-vv-as="labels.indexOn"
                  :disabled="doApplyIndex"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ mainForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(mainForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ mainForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(mainForm.modifiedDate) }}</div>
              </v-flex>
              <v-flex xs12>
                <v-spacer class="mt-3"></v-spacer>
                <v-btn color="red" dark class=" mr-2" @click="doCancel" :loading="submitting">
                  Cancel
                  <v-icon right>mdi-cancel</v-icon>
                </v-btn>
                <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                  Save Item
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { removeFormatNumber } from '@/utils/number.js'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      defStdItemTxtRef: [],
      defUOM: [],
      uomUN: [],
      defBenefit: [],
      indexOn: [],
      defClse: [],
      showIndex: false,
      labels: {
        itemNo: 'Item No./Benefit Sequence No.',
        defStdItemTxtRef: 'Default Standard Item Text',
        defUOM: 'Default UOM',
        uomUN: 'Default UOM UN',
        defBenefit: 'Default Benefit',
        uomAmt: 'Default SI/Benefit Limit',
        minSI: 'Minimum SI',
        maxSI: 'Maximum SI',
        incSI: 'Incremental SI',
        mandOnPlan: 'Mandatory on Plan',
        defClse1: 'Default Clause 1',
        defClse2: 'Default Clause 2',
        defClse3: 'Default Clause 3',
        permitDel: 'Permit Delete',
        protSI: 'Protect SI/Limit',
        protPrem: 'Protect Premium Rate',
        applyIndex: 'Apply Indexation',
        indexYr: 'Index Year',
        indexPct: 'Indexation %',
        indexOn: 'Indexation On',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      mainForm: {
        scheme: undefined,
        planNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        defStdItemTxtRef: undefined,
        defUOM: undefined,
        uomUN: undefined,
        defBenefit: 'NA',
        uomAmt: 0,
        minSI: 0,
        maxSI: 0,
        incSI: 0,
        mandOnPlan: true,
        defClse1: undefined,
        defClse2: undefined,
        defClse3: undefined,
        permitDel: false,
        protSI: true,
        protPrem: true,
        applyIndex: false,
        indexYr: 0,
        indexPct: 0,
        indexOn: 'B',
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      },
      loading: true
    }
  },
  methods: {
    async doInit() {
      this.mainForm.scheme = this.pkgRiskItemId.scheme
      this.mainForm.planNo = this.pkgRiskItemId.planNo
      this.mainForm.riskNo = this.pkgRiskItemId.riskNo
      await this.$store.dispatch('packagePlanInit')
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.doGetDefStdItemTxtRef()
      this.doGetDefUOM()
      this.doDefUomUN()
      this.doGetClause()
      this.doIndexOn()
      this.doGetDefBenefit()
      if (this.pkgRiskItemId.tranMode === 'reviewMode') {
        this.fetchData(true)
      }
    },
    async fetchData() {
      const apiURI = this.menu.getPkgRiskItem
      if (apiURI) {
        try {
          const expand = {
            scheme: this.pkgRiskItemId.scheme,
            planNo: this.pkgRiskItemId.planNo,
            riskNo: this.pkgRiskItemId.riskNo,
            itemNo: this.pkgRiskItemId.itemNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.mainForm.itemNo = data.pkgRiskItem.itemNo
            this.mainForm.defStdItemTxtRef = data.pkgRiskItem.defStdItemTxtRef
            this.mainForm.defUOM = data.pkgRiskItem.defUOM
            this.mainForm.uomUN = data.pkgRiskItem.uomUN
            this.mainForm.defBenefit = data.pkgRiskItem.defBenefit
            this.mainForm.uomAmt = data.pkgRiskItem.uomAmt
            this.mainForm.minSI = data.pkgRiskItem.minSI
            this.mainForm.maxSI = data.pkgRiskItem.maxSI
            this.mainForm.incSI = data.pkgRiskItem.incSI
            this.mainForm.mandOnPlan = data.pkgRiskItem.mandOnPlan
            this.mainForm.defClse1 = data.pkgRiskItem.defClse1
            this.mainForm.defClse2 = data.pkgRiskItem.defClse2
            this.mainForm.defClse3 = data.pkgRiskItem.defClse3
            this.mainForm.permitDel = data.pkgRiskItem.permitDel
            this.mainForm.protSI = data.pkgRiskItem.protSI
            this.mainForm.protPrem = data.pkgRiskItem.protPrem
            this.mainForm.applyIndex = data.pkgRiskItem.applyIndex
            this.mainForm.indexYr = data.pkgRiskItem.indexYr
            this.mainForm.indexPct = data.pkgRiskItem.indexPct
            this.mainForm.indexOn = data.pkgRiskItem.indexOn
            this.mainForm.createdBy = data.createdBy
            this.mainForm.createdDate = data.createdDate
            this.mainForm.modifiedBy = data.modifiedBy
            this.mainForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doGetDefStdItemTxtRef(event) {
      this.loading = true
      this.defStdItemTxtRef = []
      const apiURI = this.menu.getDefStdItemTxtRef
      if (apiURI) {
        const expand = {
          scheme: this.mainForm.scheme,
          riskNo: this.mainForm.riskNo,
          planNo: this.mainForm.planNo
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defStdItemTxtRef.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defStdItemTxtRef = []
            }
          })
          .catch((err) => {
            this.defStdItemTxtRef = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doGetDefUOM(event) {
      this.loading = true
      this.defUOM = []
      const apiURI = this.menu.getDefUOM
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defUOM.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defUOM = []
            }
          })
          .catch((err) => {
            this.defUOM = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doGetDefBenefit(event) {
      this.loading = true
      this.defBenefit = []
      const apiURI = this.menu.getDefBenefit
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defBenefit.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defBenefit = []
            }
          })
          .catch((err) => {
            this.defBenefit = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doDefUomUN(event) {
      this.loading = true
      this.uomUN = []
      const data = [
        { value: 'A', label: 'A - Not Applicable' },
        { value: 'B', label: 'B - Blank' },
        { value: 'C', label: 'C - Covered' },
        { value: 'U', label: 'U - Unlimited' },
        { value: 'N', label: 'N - Not Covered' }
      ]
      data.filter((list) => {
        this.uomUN.push({ value: list.value, label: list.label })
      })
    },
    doGetClause(event) {
      this.loading = true
      this.defClse = []
      const apiURI = this.menu.getDefClse
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defClse.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defClse = []
            }
          })
          .catch((err) => {
            this.defClse = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doIndexOn(event) {
      this.loading = true
      this.indexOn = []
      const data = [
        { value: 'B', label: 'B - Both' },
        { value: 'S', label: 'S - Sum Insured' },
        { value: 'P', label: 'P - Premium' }
      ]
      data.filter((list) => {
        this.indexOn.push({ value: list.value, label: list.label })
      })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      this.mainForm.applyIndex ? (this.mainForm.indexYr = 0) : (this.mainForm.indexYr = this.mainForm.indexYr)
      this.mainForm.applyIndex ? (this.mainForm.indexPct = 0) : (this.mainForm.indexPct = this.mainForm.indexPct)
      const apiURI = this.menu.createPkgRiskItem
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.mainForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgRiskItemList', params: { incomingRiskNo: this.incomingRiskNo } })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'pkgRiskItemList', params: { incomingRiskNo: this.incomingRiskNo } })
    },
    async doUpdate() {
      const apiURI = this.menu.updatePkgRiskItem
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.mainForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgRiskItemList', params: { incomingRiskNo: this.incomingRiskNo } })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    setValue() {
      this.$refs.childDiscPct.$el.cleave.setRawValue(this.mainForm.childDiscPct)
      this.mainForm.childDiscPct = formatPrice(this.$refs.childDiscPct.$el.cleave.getRawValue())
    },
    doPkgSubItem() {
      this.$router.push({ name: 'pkgSubItemList' })
    }
  },
  created() {
    if (this.pkgRiskItemId.tranMode === 'newMode') {
      this.newMode = true
      this.reviewMode = false
    } else {
      this.newMode = false
      this.reviewMode = true
    }

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
    const mustGreaterThenZero = {
      getMessage: (field, args) => {
        return field + ' cannot be 0'
      },
      validate: (value, args) => {
        return removeFormatNumber(value) >= 0.000001
      }
    }

    this.$validator.extend('mustGreaterThenZero', mustGreaterThenZero)
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgPlan.menu
    },
    busClsMenu() {
      return this.$store.state.busClsParam.menu
    },
    pkgRiskId() {
      return this.$store.state.pkgParam.pkgRisk.pkgRiskId
    },
    pkgRiskItemId() {
      return this.$store.state.pkgParam.pkgRiskItem.pkgRiskItemId
    },
    doApplyIndex() {
      if (!this.mainForm.applyIndex) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.doInit()
  },
  props: ['tranMode', 'incomingRiskNo', 'incomingScheme', 'incomingPlanNo'],
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
